import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';

import NotificationItem from './NotificationItem';
import CustomScrollbars from 'util/CustomScrollbars';
import { fetchJSON } from 'helpers/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const MailNotification = ({ authUser, onUnreadCountChange }) => {
  const [notifications, setNotifications] = useState([]);
  const prevIdsRef = useRef(new Set());

  useEffect(() => {
    let mounted = true;
    let timer = null;

    const fetchNotifications = async () => {
      if (!authUser) return;
      const { StaffID, token } = authUser;
      try {
        const res = await fetchJSON(`api/GetUnReadNotificationsForAdmin?staffId=${StaffID}`, null, 'GET', token);
        if (res && res.Status) {
          const items = res.Data || [];
          if (onUnreadCountChange) onUnreadCountChange(res.UnreadCount || 0);

          // detect newly arrived notifications
          const newItems = items.filter((it) => {
            const id = it.NotificationId || it.Id || it.IdNo || JSON.stringify(it);
            return !prevIdsRef.current.has(id);
          });

          if (newItems.length) {
            newItems.forEach((i) => {
              NotificationManager.info(i.Message || i.Body || 'You have a new notification', i.Title || 'Notification');
            });
          }

          // update prev ids
          prevIdsRef.current = new Set(items.map((it) => it.NotificationId || it.Id || it.IdNo || JSON.stringify(it)));

          // map to NotificationItem shape
          const mapped = items.map((it, idx) => ({
            id: it.NotificationId || it.Id || idx,
            image: it.AvatarUrl || it.SenderAvatar || '',
            badge: it.Badge || '',
            name: it.Title || it.SenderName || 'Notification',
            time: it.CreatedAt || it.CreatedOn || it.Date || '',
            message: it.Message || it.Body || '',
          }));

          if (mounted) setNotifications(mapped);
        }
      } catch (error) {
        console.error('Error fetching notifications', error);
      }
    };

    fetchNotifications();
    timer = setInterval(fetchNotifications, 30000); // poll every 30s

    return () => {
      mounted = false;
      if (timer) clearInterval(timer);
    };
  }, [authUser]);

  const markAllRead = async () => {
    if (!authUser) return;
    const { StaffID, token } = authUser;
    try {
      const res = await fetchJSON(`api/MarkNotificationsAsReadForAdmin?staffId=${StaffID}`, null, 'POST', token);
      if (res?.Status === true) {
        setNotifications([]);
        if (onUnreadCountChange) onUnreadCountChange(0); // Reset unread count
        prevIdsRef.current = new Set();
        NotificationManager.success('All notifications marked as read');
      } else {
        NotificationManager.error(res?.Message || 'Failed to mark notifications as read');
      }
    } catch (error) {
      console.error('Error marking notifications as read', error);
      NotificationManager.error('Failed to mark notifications as read');
    }
  };

  return (
    <CustomScrollbars className="messages-list scrollbar" style={{ height: 280 }}>
      <div className="d-flex justify-content-end p-2">
        <button className="btn btn-link p-0" onClick={markAllRead}>Mark all read</button>
      </div>
      <ul className="list-unstyled">
        {notifications.length ? (
          notifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} />
          ))
        ) : (
          <li className="text-center p-3">No new notifications</li>
        )}
      </ul>
      <NotificationContainer />
    </CustomScrollbars>
  );
};
const mapStateToProps = ({ auth }) => ({ authUser: auth.adminUser });

export default connect(mapStateToProps)(MailNotification);

